// extracted by mini-css-extract-plugin
export default {"imageWrapper":"iH-z","hovered":"jH-z","hoverImage":"kH-z","mainImage":"lH-z","imageNoBackground":"mH-z","fullSizeImage":"nH-z"};